import React from "react";
import { Typography, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import {
  CustomCard,
  CustomCardMedia,
  CustomCardContent,
  CustomCardActions,
  CustomButton,
  CustomCardSection,
} from "./styles/CardDestinoStyles";

const CardDestino = ({ destino }) => (
  <CustomCard>
    <CustomCardMedia
      component="img"
      alt={destino.nombre}
      image={destino.foto}
    />
    <CustomCardContent>
      <Typography
        variant="h6"
        sx={{
          fontSize: { xs: "0.9rem", sm: "1rem", md: "1.05rem" },
          fontWeight: "bold",
          color: "#333",
          lineHeight: 1.2,
          mb: 1,
        }}
      >
        {destino.nombre}
      </Typography>

      <Divider sx={{ my: 1, width: "60%" }} />

      <CustomCardSection>
        <Typography variant="body2" color="text.secondary">
          <strong>Ciudad:</strong> {destino.ciudad}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>Dirección:</strong> {destino.direccion}
        </Typography>
        {destino.like_count !== undefined && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            ❤️ {destino.like_count} {destino.like_count === 1 ? "Me gusta" : "Me gusta"}
          </Typography>
        )}
      </CustomCardSection>
    </CustomCardContent>

    <CustomCardActions>
      <CustomButton component={Link} to={`/informacion/${destino.id}`} fullWidth>
        Ubicacion
      </CustomButton>
    </CustomCardActions>
  </CustomCard>
);

export default CardDestino;
